module.exports = __webpack_public_path__ + "img/07.329f6796.png";